import React, { useEffect, useState } from "react";

import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const ProductSidebar = ({ setQuery, query }) => {
  const navigate = useNavigate();
  const location = useNavigate();
  const [priceRange, setPriceRange] = useState({
    min: query?.minPrice,
    max: query?.maxPrice,
  });
  const [search, setSearch] = useState(query?.productName || "");
  const [allMainCategories, setAllMainCategories] = useState([]);
  console.log("allMainCategories: ", allMainCategories);

  const getAllMainCategoriesDetails = async () => {
    console.log("running");

    const token = localStorage.getItem("token");
    const ipAddress = localStorage.getItem("ipaddress");

    await fetch(
      `${process.env.REACT_APP_API_URL}maincategorieslist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,

          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setAllMainCategories(data?.mainCategoryDetails);
        }
      })
      .catch((error) => {
        toast.error("There was an error, Please try again later.");
      });
  };

  useEffect(() => {
    getAllMainCategoriesDetails();
  }, []);

  return (
    <section
      id="secondary"
      class="secondary-sidebar secondary-has-left-sidebar"
    >
      <div class="wdt-sidebar-wrapper">
        <aside
          id="woocommerce_product_search-2"
          class="widget woocommerce widget_product_search"
        >
          <form
            role="search"
            class="woocommerce-product-search"
            onSubmit={(e) => {
              e.preventDefault();
              setQuery({ ...query, productName: search });
              navigate(location.pathname, { replace: true, state: null });
            }}
          >
            <label
              class="screen-reader-text"
              for="woocommerce-product-search-field-0"
            >
              Search for:
            </label>
            <input
              type="search"
              id="woocommerce-product-search-field-0"
              class="search-field"
              placeholder="Search products&hellip;"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              style={{ paddingRight: 8, cursor: "pointer" }}
            />
            <button type="submit" value="Search" class="">
              Search
            </button>
          </form>
        </aside>
        <aside
          id="woocommerce_product_categories-2"
          class="widget woocommerce widget_product_categories"
        >
          <h2 class="widgettitle align">Product Categories</h2>
          <ul class="product-categories">
            {allMainCategories?.map((item, i) => (
              <li key={i} class={`cat-item cat-item-97 `}>
                <Link
                className={`${query?.mainCategoryId === item?.id ? "active-shop-filter" : ""}`}
                  onClick={(e) => {
                    setQuery({ ...query, mainCategoryId: item?.id });
                    navigate(location.pathname, { replace: true, state: null });
                  }}
                >
                  {item?.mainCategoryName}
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        <aside
          id="woocommerce_price_filter-2"
          class="widget woocommerce widget_price_filter"
        >
          <h2 class="widgettitle align">Filter By Price</h2>
          <form>
            <InputRange
              maxValue={10000}
              minValue={0}
              value={priceRange}
              onChange={(value) => {
                setPriceRange(value);
              }}
            />
          </form>
          <div
            class="price_slider_amount "
            style={{ marginTop: 20 }}
            data-step="10"
          >
            <div class="price_label ">
              Price: <span class="from">₹&nbsp;{priceRange?.min}</span> &nbsp; —
              &nbsp;
              <span class="to">₹&nbsp;{priceRange?.max}</span>
            </div>
          </div>
          <button
            type="button"
            class="button"
            onClick={() => {
              setQuery({
                ...query,
                minPrice: priceRange?.min,
                maxPrice: priceRange?.max,
              });
              navigate(location.pathname, { replace: true, state: null });
            }}
          >
            Filter
          </button>
          <button
            style={{ backgroundColor: "black", color: "white", marginLeft: 20 }}
            type="button"
            class="button"
            onClick={() => {
              setQuery({
                ...query,
                mainCategoryId: "",
                categoryId: "",
                subCategoryId: "",
                sortingType: "default",
                minPrice: "0",
                maxPrice: "",
                productName: "",
                minRating: "",
                maxRating: "",
              });
              navigate(location.pathname, { replace: true, state: null });
            }}
          >
            Clear
          </button>
        </aside>
      </div>
    </section>
  );
};

export default ProductSidebar;
